import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { RecordInterface, SetFormValues } from '@type/form-types';
import { Switch } from '@headlessui/react';
import { SetMirrorData } from '@type/job-add';
import { Input } from '@components/common/Forms';

/** Component props */
interface JobWithoutChargeProps {
  record: RecordInterface;
  setFormValues: SetFormValues;
  setMirrorData?: SetMirrorData;
}

/**
 * @description Job activation price component.
 * - `record`: The form record.
 */
export const JobWithoutCharge = (props: JobWithoutChargeProps) => {
  // Destructure props
  const {
    setFormValues, setMirrorData, record,
  } = props;

  // Helpers
  const { t } = useTranslation('common');
  const [withoutCharge, setWithoutCharge] = useState<boolean>(false);
  // Render component
  // *************************
  return (
    <div className="mb-1 mt-5 divide-y px-4 sm:px-5">
      <div className="flex items-center justify-between py-2">
        <div className="flex flex-col">
          <span className="font-semibold">{t('job.add.label.without_charge') || 'Without charge'}</span>
          <span className="text-xs text-ink-light">{t('job.add.label.without_charge.desc') || 'Do not charge this activation.'}</span>
        </div>
        <div className="flex items-center gap-3">
          <Input
            type="hidden"
            {...record('withoutCharge', {
              convertValue: 'toBoolean',
              defaultValue: 'false',
            })}
            value={withoutCharge ? 'true' : 'false'}
            readOnly
          />

          <Switch
            checked={withoutCharge}
            onChange={(value) => {
              setWithoutCharge(value);
              setFormValues((prev) => ({
                ...prev,
                withoutCharge: value,
              }));
              setMirrorData?.({ withoutCharge: value }, false, true);
            }}
            className={`relative inline-flex h-6 w-12 items-center rounded-full transition ${withoutCharge ? 'bg-secondary' : 'bg-gray-300'}`}
            aria-label={t('job.add.label.without_charge') || 'Without charge'}
            title={t('job.add.label.without_charge') || 'Without charge'}
          >
            <span className={`inline-block size-4 rounded-full bg-white transition ${withoutCharge ? 'translate-x-6' : 'translate-x-1'}`} />
          </Switch>
        </div>
      </div>
    </div>
  );
};
